import { useContext, useRef } from 'react';
import { DiagnosticContext, useOutsideClick } from '../../helpers/functions';
import Tabs from '../Tabs';
import { getTestFields } from '../../services/londi-suggestions';
import { categories } from '../../services/londi-constants';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '../../elements/container';
import PageHeading from '../../elements/page-heading';
import Button from '../../elements/button';

const CompetenceLevelsTest = ({ el, level, index, inputChange, value }) => {
  const InvalidMsg = (num) => {
    if (num.validity.valueMissing) {
      num?.setCustomValidity('Bitte wählen Sie eine Zahl zwischen 0 und 100');
    } else if (num?.value > 100 || num?.value < 0) {
      num?.setCustomValidity('Bitte wählen Sie eine Zahl zwischen 0 und 100');
    } else {
      num?.setCustomValidity('');
    }
    return true;
  };
  return (
    el.competenceLevel === level && (
      <div key={index} className="flex flex-col">
        <div className="mt-4">
          <p className="w-full sm:w-60 text-sm sm:text-base">{el.title}</p>
          <div className="flex flex-wrap items-center gap-2 mt-1">
            <input
              value={value || ''}
              onChange={inputChange}
              className="btn-options w-20 sm:w-24 h-10 sm:h-8 text-base"
              type="number"
              onInvalid={(e) => InvalidMsg(e.target)}
              onInput={(e) => InvalidMsg(e.target)}
              required={el.competenceLevel === 3 || el.competenceLevel === 1}
              placeholder="0-100"
            />
            <label className="text-base sm:text-lg flex items-center" htmlFor="test">
              Prozentrang
            </label>
          </div>
        </div>
      </div>
    )
  );
};

const TestResults = () => {
  const { state, dispatch } = useContext(DiagnosticContext);
  const wrapperRef = useRef(null);
  const testFieldsReading = useMemo(() => getTestFields(state.readingTestId, categories.Reading), [state.readingTestId]);
  const testFieldsReadingSecond = useMemo(() => getTestFields(state.readingSecondTestId, categories.Reading), [state.readingSecondTestId]);
  const testFieldsReadingThird = useMemo(() => getTestFields(state.readingThirdTestId, categories.Reading), [state.readingThirdTestId]);
  const testFieldsWriting = useMemo(() => getTestFields(state.writingTestId, categories.Writing), [state.writingTestId]);
  const testFieldsWritingSecond = useMemo(() => getTestFields(state.writingSecondTestId, categories.Writing), [state.writingSecondTestId]);
  const testFieldsWritingThird = useMemo(() => getTestFields(state.writingThirdTestId, categories.Writing), [state.writingThirdTestId]);
  const testFieldsCounting = useMemo(() => getTestFields(state.countingTestId, categories.Math), [state.countingTestId]);
  const testFieldsCountingSecond = useMemo(() => getTestFields(state.countingSecondTestId, categories.Math), [state.countingSecondTestId]);
  const testFieldsCountingThird = useMemo(() => getTestFields(state.countingThirdTestId, categories.Math), [state.countingThirdTestId]);

  useOutsideClick(wrapperRef);
  const navigate = useNavigate();
  const onSubmit = () => {
    const allFields = [
      ...testFieldsReading,
      ...testFieldsReadingSecond,
      ...testFieldsReadingThird,
      ...testFieldsWriting,
      ...testFieldsWritingSecond,
      ...testFieldsWritingThird,
      ...testFieldsCounting,
      ...testFieldsCountingSecond,
      ...testFieldsCountingThird,
    ];
    const levels = new Set(allFields.map((f) => f.competenceLevel));
    if (levels.size < 4) {
      navigate('/self-assessment');
    } else {
      navigate('/funding-recomendations');
    }
  };

  //if (state?.screenResultsEstimated) return;

  return (
    <>
      <Tabs />
      <Container className="flex flex-col items-center">
        <PageHeading stretch title="Testergebnisse" />
        <div className="max-w-6xl py-6 space-y-4 -mt-6">
          Bitte geben Sie die Ergebnisse der Tests ein. Es sind mindestens ein Wert für die{' '}
          <a href="https://londi.de/lehrkr%C3%A4fte/lehrkr%C3%A4fte-hilfssystem#das-londi-kompetenzstufenmodell" target="_blank" className="underline hover:text-mainBlue" rel="noreferrer">
            Kompetenzstufe
          </a>{' '}
          1 und ein Wert für die{' '}
          <a href="https://londi.de/lehrkr%C3%A4fte/lehrkr%C3%A4fte-hilfssystem#das-londi-kompetenzstufenmodell" target="_blank" className="underline hover:text-mainBlue" rel="noreferrer">
            Kompetenzstufe
          </a>{' '}
          3 erforderlich.
        </div>
        <form onSubmit={onSubmit} className="flex flex-col items-center w-full px-4 sm:px-0">
          <div className="flex flex-col lg:flex-row flex-wrap justify-between w-full max-w-6xl gap-4 lg:gap-8">
            <div className={`${state.readingResults ? 'flex mt-4 sm:mt-7' : 'hidden'}`}>
              <div className="flex flex-col w-full">
                {state.readingResults && <p className="text-xl sm:text-2xl font-semibold">Lesen</p>}
                <div className="flex flex-wrap">
                  <div className="flex flex-col ml-0 sm:ml-1 w-full">
                    <p className="text-lg sm:text-2xl mt-2 sm:mt-4 font-semibold">{state.readingResults}</p>
                    <div className="flex flex-wrap gap-x-4">
                      <div className="flex flex-col">
                        {testFieldsReading.map((el) => el.competenceLevel === 1).includes(true) && (
                          <p className="text-lg mt-2 font-semibold">Kompetenzstufe 1</p>
                        )}
                        <div className={`${testFieldsReading.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                          {testFieldsReading.map((el, index) => {
                            return (
                              <CompetenceLevelsTest
                                inputChange={(e) => {
                                  dispatch({
                                    type: 'resultsReading',
                                    payload: { keyReading: index, valueReading: e.target.value },
                                  });
                                }}
                                el={el}
                                index={index}
                                level={1}
                                value={state?.resultsReading?.[index]}
                              />
                            );
                          })}
                        </div>
                      </div>
                      <div className="flex flex-col">
                        {testFieldsReading.map((el) => el.competenceLevel === 2).includes(true) && (
                          <p className="text-lg mt-2 font-semibold">Kompetenzstufe 2</p>
                        )}

                        <div className={`${testFieldsReading.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                          {testFieldsReading.map((el, index) => {
                            return (
                              <CompetenceLevelsTest
                                inputChange={(e) => {
                                  dispatch({
                                    type: 'resultsReading',
                                    payload: { keyReading: index, valueReading: e.target.value },
                                  });
                                }}
                                el={el}
                                index={index}
                                level={2}
                                value={state?.resultsReading?.[index]}
                              />
                            );
                          })}
                        </div>
                      </div>
                      <div className="flex flex-col">
                        {testFieldsReading.map((el) => el.competenceLevel === 3).includes(true) && (
                          <p className="text-lg mt-2 font-semibold">Kompetenzstufe 3</p>
                        )}

                        <div className={`${testFieldsReading.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                          {testFieldsReading.map((el, index) => {
                            return (
                              <CompetenceLevelsTest
                                inputChange={(e) => {
                                  dispatch({
                                    type: 'resultsReading',
                                    payload: { keyReading: index, valueReading: e.target.value },
                                  });
                                }}
                                el={el}
                                index={index}
                                level={3}
                                value={state?.resultsReading?.[index]}
                              />
                            );
                          })}
                        </div>
                      </div>
                      <div className="flex flex-col">
                        {testFieldsReading.map((el) => el.competenceLevel === 4).includes(true) && (
                          <p className="text-lg mt-2 font-semibold">Kompetenzstufe 4</p>
                        )}
                        <div className={`${testFieldsReading.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                          {testFieldsReading.map((el, index) => {
                            return (
                              <CompetenceLevelsTest
                                inputChange={(e) => {
                                  dispatch({
                                    type: 'resultsReading',
                                    payload: { keyReading: index, valueReading: e.target.value },
                                  });
                                }}
                                el={el}
                                index={index}
                                level={4}
                                value={state?.resultsReading?.[index]}
                              />
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  {state.readingThirdTestResults && (
                    <div className="flex flex-col ml-1 w-full">
                      <p className="text-2xl mt-4 font-semibold">{state.readingThirdTestResults}</p>
                      <div className="flex flex-wrap">
                        <div className="flex flex-col">
                          {testFieldsReadingThird.map((el) => el.competenceLevel === 1).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 1</p>
                          )}

                          <div className={`${testFieldsReadingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsReadingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdReading',
                                      payload: { keyThirdReading: index, valueThirdReading: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={1}
                                  value={state?.resultsThirdReading?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsReadingThird.map((el) => el.competenceLevel === 2).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 2</p>
                          )}

                          <div className={`${testFieldsReadingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsReadingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdReading',
                                      payload: { keyThirdReading: index, valueThirdReading: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={2}
                                  value={state?.resultsThirdReading?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsReadingThird.map((el) => el.competenceLevel === 3).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 3</p>
                          )}

                          <div className={`${testFieldsReadingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsReadingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdReading',
                                      payload: { keyThirdReading: index, valueThirdReading: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={3}
                                  value={state?.resultsThirdReading?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsReadingThird.map((el) => el.competenceLevel === 4).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 4</p>
                          )}
                          <div className={`${testFieldsReadingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsReadingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdReading',
                                      payload: { keyThirdReading: index, valueThirdReading: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={4}
                                  value={state?.resultsThirdReading?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={`${state.writingResults ? 'flex mt-4 sm:mt-7' : 'hidden'}`}>
              <div className="flex flex-col w-full">
                {state.writingResults && <p className="text-xl sm:text-2xl font-semibold">Schreiben</p>}
                <div className="flex flex-wrap">
                  <div className="flex flex-col ml-0 sm:ml-1 w-full">
                    <p className="text-lg sm:text-2xl mt-2 sm:mt-4 font-semibold">{state.writingResults}</p>
                    <div className="flex flex-wrap gap-x-4">
                      <div className="flex flex-col">
                        {testFieldsWriting.map((el) => el.competenceLevel === 1).includes(true) && (
                          <p className="text-lg mt-2 font-semibold">Kompetenzstufe 1</p>
                        )}
                        <div className={`${testFieldsWriting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                          {testFieldsWriting.map((el, index) => {
                            return (
                              <CompetenceLevelsTest
                                inputChange={(e) => {
                                  dispatch({
                                    type: 'resultsWriting',
                                    payload: { keyWriting: index, valueWriting: e.target.value },
                                  });
                                }}
                                el={el}
                                index={index}
                                level={1}
                                value={state?.resultsWriting?.[index]}
                              />
                            );
                          })}
                        </div>
                      </div>
                      <div className="flex flex-col">
                        {testFieldsWriting.map((el) => el.competenceLevel === 2).includes(true) && (
                          <p className="text-lg mt-2 font-semibold">Kompetenzstufe 2</p>
                        )}
                        <div className={`${testFieldsWriting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                          {testFieldsWriting.map((el, index) => {
                            return (
                              <CompetenceLevelsTest
                                inputChange={(e) => {
                                  dispatch({
                                    type: 'resultsWriting',
                                    payload: { keyWriting: index, valueWriting: e.target.value },
                                  });
                                }}
                                el={el}
                                index={index}
                                level={2}
                                value={state?.resultsWriting?.[index]}
                              />
                            );
                          })}
                        </div>
                      </div>
                      <div className="flex flex-col">
                        {testFieldsWriting.map((el) => el.competenceLevel === 3).includes(true) && (
                          <p className="text-lg mt-2 font-semibold">Kompetenzstufe 3</p>
                        )}

                        <div className={`${testFieldsWriting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                          {testFieldsWriting.map((el, index) => {
                            return (
                              <CompetenceLevelsTest
                                inputChange={(e) => {
                                  dispatch({
                                    type: 'resultsWriting',
                                    payload: { keyWriting: index, valueWriting: e.target.value },
                                  });
                                }}
                                el={el}
                                index={index}
                                level={3}
                                value={state?.resultsWriting?.[index]}
                              />
                            );
                          })}
                        </div>
                      </div>
                      <div className="flex flex-col">
                        {testFieldsWriting.map((el) => el.competenceLevel === 4).includes(true) && (
                          <p className="text-lg mt-2 font-semibold">Kompetenzstufe 4</p>
                        )}
                        <div className={`${testFieldsWriting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                          {testFieldsWriting.map((el, index) => {
                            return (
                              <CompetenceLevelsTest
                                inputChange={(e) => {
                                  dispatch({
                                    type: 'resultsWriting',
                                    payload: { keyWriting: index, valueWriting: e.target.value },
                                  });
                                }}
                                el={el}
                                index={index}
                                level={4}
                                value={state?.resultsWriting?.[index]}
                              />
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                  {state.writingThirdTestResults && (
                    <div className="flex flex-col ml-1 w-full">
                      <p className="text-2xl mt-4 font-semibold">{state.writingThirdTestResults}</p>
                      <div className="flex flex-wrap">
                        <div className="flex flex-col">
                          {testFieldsWritingThird.map((el) => el.competenceLevel === 1).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 1</p>
                          )}

                          <div className={`${testFieldsWritingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsWritingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdWriting',
                                      payload: { keyThirdWriting: index, valueThirdWriting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={1}
                                  value={state?.resultsThirdWriting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsWritingThird.map((el) => el.competenceLevel === 2).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 2</p>
                          )}

                          <div className={`${testFieldsWritingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsWritingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdWriting',
                                      payload: { keyThirdWriting: index, valueThirdWriting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={2}
                                  value={state?.resultsThirdWriting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsWritingThird.map((el) => el.competenceLevel === 3).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 3</p>
                          )}

                          <div className={`${testFieldsWritingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsWritingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdWriting',
                                      payload: { keyThirdWriting: index, valueThirdWriting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={3}
                                  value={state?.resultsThirdWriting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsWritingThird.map((el) => el.competenceLevel === 4).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 4</p>
                          )}
                          <div className={`${testFieldsWritingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsWritingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdWriting',
                                      payload: { keyThirdWriting: index, valueThirdWriting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={4}
                                  value={state?.resultsThirdWriting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={`${state.countingResults ? 'flex mt-4 sm:mt-7' : 'hidden'}`}>
              <div className="flex flex-col w-full">
                {state.countingResults && <p className="text-xl sm:text-2xl font-semibold">Rechnen</p>}
                <div className="flex flex-wrap">
                  <div className="flex flex-col ml-0 sm:ml-1 w-full">
                    <p className="text-lg sm:text-2xl mt-2 sm:mt-4 font-semibold">{state.countingResults}</p>
                    <div className={`${testFieldsCounting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                      <div className="flex flex-wrap">
                        <div className="flex flex-col">
                          {testFieldsCounting.map((el) => el.competenceLevel === 1).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 1</p>
                          )}

                          <div className={`${testFieldsCounting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsCounting.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsCounting',
                                      payload: { keyCounting: index, valueCounting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={1}
                                  value={state?.resultsCounting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsCounting.map((el) => el.competenceLevel === 2).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 2</p>
                          )}

                          <div className={`${testFieldsCounting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsCounting.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsCounting',
                                      payload: { keyCounting: index, valueCounting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={2}
                                  value={state?.resultsCounting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsCounting.map((el) => el.competenceLevel === 3).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 3</p>
                          )}

                          <div className={`${testFieldsCounting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsCounting.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsCounting',
                                      payload: { keyCounting: index, valueCounting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={3}
                                  value={state?.resultsCounting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsCounting.map((el) => el.competenceLevel === 4).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 4</p>
                          )}
                          <div className={`${testFieldsCounting.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsCounting.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsCounting',
                                      payload: { keyCounting: index, valueCounting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={4}
                                  value={state?.resultsCounting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {state.countingThirdTestResults && (
                    <div className="flex flex-col ml-1 w-full">
                      <p className="text-2xl mt-4 font-semibold">{state.countingThirdTestResults}</p>
                      <div className="flex flex-wrap">
                        <div className="flex flex-col">
                          {testFieldsCountingThird.map((el) => el.competenceLevel === 1).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 1</p>
                          )}

                          <div className={`${testFieldsCountingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsCountingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdCounting',
                                      payload: { keyThirdCounting: index, valueThirdCounting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={1}
                                  value={state?.resultsThirdCounting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsCountingThird.map((el) => el.competenceLevel === 2).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 2</p>
                          )}

                          <div className={`${testFieldsCountingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsCountingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdCounting',
                                      payload: { keyThirdCounting: index, valueThirdCounting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={2}
                                  value={state?.resultsThirdCounting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsCountingThird.map((el) => el.competenceLevel === 3).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 3</p>
                          )}

                          <div className={`${testFieldsCountingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsCountingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdCounting',
                                      payload: { keyThirdCounting: index, valueThirdCounting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={3}
                                  value={state?.resultsThirdCounting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          {testFieldsCountingThird.map((el) => el.competenceLevel === 4).includes(true) && (
                            <p className="text-lg mt-2 font-semibold">Kompetenzstufe 4</p>
                          )}
                          <div className={`${testFieldsCountingThird.length > 5 ? 'flex-wrap' : 'flex-col'} flex flex-row  flex-wrap`}>
                            {testFieldsCountingThird.map((el, index) => {
                              return (
                                <CompetenceLevelsTest
                                  inputChange={(e) => {
                                    dispatch({
                                      type: 'resultsThirdCounting',
                                      payload: { keyThirdCounting: index, valueThirdCounting: e.target.value },
                                    });
                                  }}
                                  el={el}
                                  index={index}
                                  level={4}
                                  value={state?.resultsThirdCounting?.[index]}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Button size="sm" type="submit" className="my-12">
            Weiter
          </Button>
        </form>
      </Container>
    </>
  );
};

export default TestResults;
